import { forwardRef } from 'react';
import { useGlobalState } from '../../App/globalState';
import TextWrapper from './style/textWrapper';

const Text = forwardRef((props, ref) => {
  const { children, ...textProps } = props;
  const { globalState } = useGlobalState();
  const { language } = globalState || {};

  return (
    <TextWrapper {...textProps} ref={ref} $language={language}>
      {children}
    </TextWrapper>
  );
});

Text.displayName = 'Text';
export default Text;
